<template><div><tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

</tile-question-layout></div></template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareEscutcheon from "../DesignerQuestionHardwareEscutcheon.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareEscutcheon,
        ],
        computed: {
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            }
        }
    }

</script>
